import { rangeSlider } from './styles.css'

interface Props {
  max: number
  min: number
  name: string
  onChange: (value: number) => void
  onChangeEnd: () => void
  scale: number
  value: number
}

export const SingleRangeSlider: React.FC<Props> = ({
  max,
  min,
  name,
  onChange,
  onChangeEnd,
  scale = 1,
  value,
  ...props
}) => {
  return (
    <input
      className={rangeSlider}
      max={trunc(max)}
      min={trunc(min)}
      name={name}
      type="range"
      value={trunc(value)}
      onChange={(e) => onChange(pow(e.currentTarget.value))}
      onMouseUp={() => onChangeEnd()}
      onTouchEnd={() => onChangeEnd()}
      {...props}
    />
  )

  function trunc(val: number) {
    return Math.trunc(val / scale)
  }

  function pow(val: string) {
    return parseInt(val) * scale
  }
}
